// extracted by mini-css-extract-plugin
export default {"AllCollects":"AllCollects_AllCollects__JguJf"};